/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/43fgc52/screen/55854690
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { find, isEmpty, isNil, propEq } from 'ramda';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import * as DocumentCard from '@components/LibraryDocumentCard';
import AppActions from '~/actions/app';
import DevelopActions from '~/actions/develop';
import { loading } from '~/services/util';
import withNavigate from '~/hocs/withNavigate';

class DocumentDetail extends React.Component {
    constructor(props) {
        super(props);

        const type = props.match?.params?.activeTab;
        const id = Number(props.match?.params?.id || 0);
        let document = null;
        const { templates } = props;
        if (!isNil(id)) {
            document = find(propEq('id', id), templates[`${type}`].data);
        }

        this.state = { document, type };
    }

    handleUpdate = (e) => {
        this.props.updateDocument(e, null, null);
    };

    handleToggle = (e) => {
        this.props.toggleModal(e);
    };

    handleChange = (e, document) => {
        const selectedMenu = e[0].value;
        if (selectedMenu === 'Assign') {
            this.handleToggle({
                type: 'Assign Document',
                data: { before: { documents: [''] }, after: [] },
            });
        } else {
            const { type } = this.state;
            this.props.navigate(`/library/documents/${type}/${document.id}/edit`);
        }
    };

    render() {
        const { busy, disabled, authors, departments, competencies, categories, isAdmin } = this.props;
        const { document } = this.state;

        if (isNil(document)) return null;

        return (
            <ErrorBoundary>
                <DocumentCard.Detail
                    isAdmin={isAdmin}
                    type={this.props.params?.activeTab}
                    navigate={this.props.navigate}
                    location={this.props.location}
                    busy={busy}
                    disabled={disabled}
                    document={document}
                    authors={authors}
                    departments={departments}
                    competencies={competencies}
                    categories={categories}
                    onModal={this.handleModal}
                    onUpdate={this.handleUpdate}
                    onToggle={this.handleToggle}
                    onChange={(e) => this.handleChange(e, document)}
                />
            </ErrorBoundary>
        );
    }
}

DocumentDetail.propTypes = {
    isAdmin: PropTypes.bool,
    busy: PropTypes.bool,
    disabled: PropTypes.bool,
    templates: PropTypes.any,
    authors: PropTypes.any,
    departments: PropTypes.array,
    competencies: PropTypes.array,
    categories: PropTypes.array,
    toggleModal: PropTypes.func,
};

DocumentDetail.defaultProps = {
    isAdmin: false,
    busy: false,
    disabled: false,
    templates: {},
    authors: [],
    departments: [],
    competencies: [],
    categories: [],
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    isAdmin: state.app.app_role_id < 3,
    busy: loading(state.develop.status),
    disabled: !(isEmpty(state.app.modalType) || isNil(state.app.modalType)),
    templates: state.develop.templates,
    authors: state.app.authors,
    departments: state.app.departments,
    competencies: state.app.competencies,
    categories: state.app.categories,
});

const mapDispatchToProps = (dispatch) => ({
    updateDocument: (payload, thumbnail, attachment) => dispatch(DevelopActions.adddocumentRequest(payload, thumbnail, attachment)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const DocumentDetailWithNavigate = withNavigate(DocumentDetail);

export default connect(mapStateToProps, mapDispatchToProps)(DocumentDetailWithNavigate);
